
export default function HeroSection() {
  return (
    <section 
      className="relative min-h-[600px] bg-cover bg-center bg-no-repeat flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/61e9306eb81488a5de052e2f6c6e0c3f.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          {/* Agent Photo */}
          <div className="mb-8">
            <div className="w-32 h-32 mx-auto rounded-full overflow-hidden border-4 border-white shadow-lg">
              <img 
                src="https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/ad4f5da2ac42da7f786a1a3a05f8fd28.png"
                alt="Jeffery Long - Real Estate Agent"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Agent Info */}
          <h1 className="text-5xl font-bold mb-4">Jeffery Long</h1>
          <p className="text-xl mb-2">CA DRE# 02234432</p>
          <h2 className="text-2xl mb-6 hidden sm:block">
            Northern / Central Valley - eXp Realty of Northern California, Inc. CA DRE#02188495
          </h2>
          
          {/* Tagline */}
          <div className="mb-8">
            <p className="text-2xl font-semibold">
              40 Years in Real Estate. Let my team support your journey.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
